import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollAnchorHandler(event) {
    
    const location = window.location.hash;
    
    useEffect(() => {
        if (!location) return;
        const onPageLoad = () => {
            const myDivElement = document.querySelector(location + '_hash');
            if (myDivElement) {
                setTimeout(() => {
                    myDivElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 500);
            }
        }

     // Check if the page has already loaded 
     if (document.readyState === 'complete') {
        onPageLoad();
    } else {
        window.addEventListener('load', onPageLoad, false);
        // Remove the event listener when component unmounts 
        return () => window.removeEventListener('load', onPageLoad);
        }
    }, [location]);
}